<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
   return{

   }
  },
  created(){
      window.addEventListener("mousewheel",function (event) {
      if (event.ctrlKey === true || event.metaKey) {event.preventDefault();}},{ passive: false })



  },
  mounted(){

  },
  methods: {

  },
}
</script>

<style>

 *{
   margin: 0;
   padding: 0;
 }
 .icon {
       width: 1em; height: 1em;
       vertical-align: -0.15em;
       fill: currentColor;
       overflow: hidden;
    }


</style>



// WEBPACK FOOTER //
// src/App.vue